import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import axios from 'axios';

axios.interceptors.request.use(config => {
  let tenantEmail = 'PENSENSE_DEFAULT';
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.tenantEmail && user.tenantEmail.trim() !== '') {
      tenantEmail = user.tenantEmail;
    }
  } catch (e) {}

  if (!config.headers['X-Tenant-ID']) {
    config.headers['X-Tenant-ID'] = tenantEmail;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();
